$(document).ready(function() {
  /** Mobile Nav Toggle */
  $('.header-links-wrapper .mobile-burger').on('click', function() {
    $('.icon-hamburger').toggleClass('hidden');
    $('.icon-close').toggleClass('hidden');
    $('.header-mobile-dropdown').slideToggle();
  });

  /** Slider Sections */
  $('.testimonial-swiper-wrapper-virtual').on('init', function(event, slick) {
    var swiperHeight = $(this).height();
    $('.testimonial-swiper-wrapper').css('min-height', swiperHeight);
  });

  $('div[class*="testimonial-swiper-wrapper"], .highlight-swiper-wrapper').slick({
    centerMode: true,
    centerPadding: '14%',
    slidesToShow: 3,
    swipeToSlide: true,
    arrows: false,
    dots: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          centerPadding: '5%',
        }
      },
      {
        breakpoint: 1025,
        settings: {
          centerPadding: '0%',
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          centerPadding: '26%',
        }
      },
      {
        breakpoint: 648,
        settings: {
          slidesToShow: 1,
          centerPadding: '14%',
        }
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 1,
          centerPadding: '2%',
        }
      },
    ]
  });

  /** Accordiion */
  $('.accordions .accordion-heading').on('click', function(e) {
    $this = $(this);
    $target =  $this.next('.accordion-content');

    if ( !$this.hasClass('active') ){
      $this.parents('.accordions').find('.accordion-heading').removeClass('active');
      $this.parents('.accordions').find('.accordion-content').slideUp();
      // $('.accordions .accordion-heading').removeClass('active');
      // $('.accordions .accordion-content').slideUp();
      $this.addClass('active');
      $target.slideDown();
    } else {
      $this.removeClass('active');
      $target.slideUp();
    }
    
    return false;
  });

  /** Anchor Group Links */
  var offsetHeight = $('header.header-wrapper').height() + $('.anchor-group-wrapper').outerHeight();

  $(window).scroll(function () {
    var fromTop = $(window).scrollTop() + offsetHeight;
    
    $('.anchor-group-wrapper a').each(function() {
      var currLink = $(this);
      var refElement = $(currLink.attr("href"));
      
      if (refElement.position().top <= fromTop + 1 && refElement.position().top + refElement.outerHeight() > fromTop) {
        $('.anchor-group-wrapper a button').removeClass("active");
        currLink.find('button').addClass("active");
      } else {
        currLink.removeClass("active");
      }
    });
  });

  $(".anchor-group-wrapper a").click(function(event) {
    event.preventDefault();
    
    $("html, body").animate({
      scrollTop: $($(this).attr("href")).offset().top - offsetHeight
    }, 500);
  });

  /** Login Trigger */
  $('.recover-password').on('click', function(e) {
    e.preventDefault();

    $('#CustomerLoginForm').addClass('hidden');
    $('#RecoverPasswordForm').removeClass('hidden');
  });

  $('.return-login').on('click', function(e) {
    e.preventDefault();

    $('#CustomerLoginForm').removeClass('hidden');
    $('#RecoverPasswordForm').addClass('hidden');
  });

  /** Meal Popup */
  $('.product-meal-item .meal-popup-action').on('click', function() {
    var $this = $(this);
    $this.parents('.product-meal-item').find('.meal-popup-box').addClass('show');
    $('body').addClass('overflow-y-hidden');
  });

  $('.meal-popup-box .close-popup').on('click', function() {
    var $this = $(this);
    $this.parents('.meal-popup-box').removeClass('show');
    $('body').removeClass('overflow-y-hidden');
  });

  /** Extra Popup */
  $(document).on('click', '.js-extra-btn', function() {
    $('.extra-meal-selection').addClass('show');
    $('body').addClass('overflow-y-hidden--extra');
  });
  $('.extra-meal-selection .close-popup--extra').on('click', function() {
    $('.extra-meal-selection').removeClass('show');
    $('body').removeClass('overflow-y-hidden--extra');
    $('.plan-checkout-btn').removeClass('js-extra-btn');
    $('.plan-checkout-btn').addClass('js-checkout-btn');
  });

  /** Meal Qty Plan */
  var limitQty = $('.total-meals-limit');
  var limitPrice = $('.total-meals-price');
  var currentQty = $('.current-meals-qty');
  var extraQty = $('.extra-meals-qty');
  var planDay = $('#meal-plan-day');
  var planStep = $('#meal-plan-step');
  var cartParams = [];

  $('.qty-selection-inner .plan-qty-item').on('click', function() {
    var $this = $(this);
    
    limitQty.val( parseInt($this.attr('data-title')) ).trigger("change");
    limitPrice.val( parseInt($this.attr('data-price')) ).trigger("change");
    planStep.val(2).trigger("change");

    $('.qty-selection-inner .plan-qty-item').removeClass('active');
    $this.addClass('active');
    $('.product-plan.day-select-plan').removeClass('pointer-events-none');
  });

  /** Meal Day Plan */
  $('.day-selectbox-wrap .plan-day-item').on('click', function() {
    var $this = $(this);

    planDay.val($this.data('day')).trigger('change');

    if ( parseInt(planStep.val()) < 2 ) {
      planStep.val(2).trigger("change");
    }
    $('.day-selectbox-wrap .plan-day-item').removeClass('active');
    $this.addClass('active');
    $('.product-meals.meals-selection').removeClass('pointer-events-none');
  });

  /** Meal Qty Control */
  $('.product-meal-item .add-cart-btn').on('click', function() {

    var $this = $(this);
    var mealQty = $this.parents('.product-meal-item').find('.meal-qty');

    mealQty.val(1).trigger("change");
    $this.removeClass('active');
    $this.next().addClass('active');

    if ( $this.parents('.product-meal-item').hasClass('extra-meal') ) {
      extraQty.val(parseInt(extraQty.val()) + 1).trigger("change");
    } else {
      currentQty.val(parseInt(currentQty.val()) + 1).trigger("change");
    }
  });

  $('.product-meal-item .qty-selection-wrap .qty-minus').on('click', function(e) {
    if ($(this).parents('.product-meal-item').hasClass('rc-upsell')) {
      return;
    }
    var mealQty = $(this).parents('.product-meal-item').find('.meal-qty');
    var qtyVal = mealQty.val();

    if (qtyVal > 0) {
      mealQty.val(parseInt(qtyVal) - 1).trigger("change"); 

      if ( $(this).parents('.product-meal-item').hasClass('extra-meal') ) {
        extraQty.val(parseInt(extraQty.val()) - 1).trigger("change");
      } else {
        currentQty.val(parseInt(currentQty.val()) - 1).trigger("change");
      }

      if (qtyVal == 1) {
        $(this).parent().removeClass('active');
        $(this).parent().prev().addClass('active');
      } else {
        $(this).parent().find('.value').val(parseInt(qtyVal) - 1);
      }
    }
  });

  $('.product-meal-item .qty-selection-wrap .qty-plus').on('click', function() {
    if ($(this).parents('.product-meal-item').hasClass('rc-upsell')) {
      return;
    }
    var mealQty = $(this).parents('.product-meal-item').find('.meal-qty');
    var qtyVal = mealQty.val();

    mealQty.val(parseInt(qtyVal) + 1).trigger("change"); 
    
    if ( $(this).parents('.product-meal-item').hasClass('extra-meal') ) {
      extraQty.val(parseInt(extraQty.val()) + 1).trigger("change");
    } else {
      currentQty.val(parseInt(currentQty.val()) + 1).trigger("change");
    }

    $(this).parent().find('.value').val(parseInt(qtyVal) + 1);
  });

  $('.product-meal-item .qty-selection-wrap .value').on('change', function() {
    if ($(this).parents('.product-meal-item').hasClass('rc-upsell')) {
      return;
    }
    var mealQty = $(this).parents('.product-meal-item').find('.meal-qty');
    var qtyVal = mealQty.val();
    let thisQty = 0;
    if ($(this).val()) {
      thisQty = parseInt($(this).val());
    }
    else {
      $(this).val(0);
    }

    mealQty.val(thisQty).trigger("change"); 

    let extraQtyValue = 0, currentQtyValue = 0;
    $('.main-meal-selection .product-meal-item').each(function () {
      let itemQty = parseInt($(this).find('.meal-qty').val());
      currentQtyValue += itemQty;
    });
    $('.extra-meal-selection .product-meal-item').each(function () {
      let itemQty = parseInt($(this).find('.meal-qty').val());
      extraQtyValue += itemQty;
    });
    
    if ( $(this).parents('.product-meal-item').hasClass('extra-meal') ) {
      extraQty.val(extraQtyValue).trigger("change");
    } else {
      currentQty.val(currentQtyValue).trigger("change");
    }


  });

  /** Weekly Menu Tab **/
  
  $(".weekly-meals-date-tab").on("click", function () {
    $(".weekly-meals-date-tab").removeClass("active");
    $(this).addClass("active");
    $(".main-meal-selection .meals-grid-wrap").hide();
    $("#weekly-meals-selection-"+$(this).data("idx")).show();
  });
  
  /** Order Summary */
  var summaryLimitQty = $('.meals-selection .summary-head .limit-qty');
  var summaryCurrQty = $('.meals-selection .summary-head .current-qty');
  var summaryExtraQty = $('.meals-selection .summary-head .extra-meal-qty');

  // Initiallize
  summaryLimitQty.text(limitQty.val());
  $('.order-summary .summary-description .add-more-desc .value').text(parseInt(limitQty.val()) - parseInt(currentQty.val()));

  var amountCalculation = () => {



    var totalQtyAdded = parseInt(currentQty.val()) + parseInt(extraQty.val()); 


    // console.log(currentQty.val());
    // console.log(extraQty.val());
    // console.log("amountCalculation: "+totalQtyAdded);
    if (parseInt(totalQtyAdded) >= 1) {
      planStep.val(2).trigger("change");

      if ($('.rc-update-fuel').length) {
        $('.rc-update-fuel').prop('disabled', false);
      }
      if (parseInt(totalQtyAdded) >= 6) {
        $('.plan-checkout-btn').attr("disabled", false);
      } else {
        $('.plan-checkout-btn').attr("disabled", true);
      }

      if (window.company_account){
        if (window.company_account.active){
          $('.plan-checkout-btn').attr("disabled", false);
          
        } 
      }


    } else {
      $('.plan-checkout-btn').attr("disabled", true);
    }
    

    // if (parseInt(currentQty.val()) >= 1) {
    //   planStep.val(2).trigger("change");

    //   if ($('.rc-update-fuel').length) {
    //     $('.rc-update-fuel').prop('disabled', false);
    //   }
    //   if (parseInt(currentQty.val()) >= 6) {
    //     $('.plan-checkout-btn').attr("disabled", false);
    //   } else {
    //     $('.plan-checkout-btn').attr("disabled", true);
    //   }
    // } else {
    //   $('.plan-checkout-btn').attr("disabled", true);
    // }

    //update current status
    $(".save-state").hide();

  }

  amountCalculation();

  // Changing
  limitQty.change(function() {
    summaryLimitQty.text($(this).val());
    amountCalculation();
  });

  summaryCurrQty.text(currentQty.val());
  currentQty.change(function() {
    //console.log(currentQty.val());
    summaryCurrQty.text($(this).val());

    var totalPriceCalc = 0.0;
    $('.product-meal-item').each(function() {
      var $this = $(this);
      var price = $this.find('.meal-qty').attr('data-price');
      var qty = $this.find('.meal-qty').val();

      totalPriceCalc = totalPriceCalc + (parseFloat(price) * parseFloat(qty));
    });

    //$('.order-checkout .checkout-info .value').text(totalPriceCalc.toFixed(2));
    $('.order-checkout .checkout-info .value').text("ON INVOICE");

    amountCalculation();
  });

  summaryExtraQty.text(extraQty.val());
  extraQty.change(function() {



    summaryExtraQty.text($(this).val());

    var totalPriceCalc = 0.0;
    $('.product-meal-item').each(function() {
      var $this = $(this);
      var price = $this.find('.meal-qty').attr('data-price');
      var qty = $this.find('.meal-qty').val();

      totalPriceCalc = totalPriceCalc + (parseFloat(price) * parseFloat(qty));
    });

    //$('.order-checkout .checkout-info .value').text(totalPriceCalc.toFixed(2));
    $('.order-checkout .checkout-info .value').text("ON INVOICE");

    amountCalculation();
  })

  // Added Meals Trigger
  $('.product-meal-item .meal-qty').each(function() {
    var $this = $(this);

    var mealQtyCtrler = () => {
      var addedMeal = $this;
      var itemWrap = addedMeal.parent('.product-meal-item');
      var mealProductID = addedMeal.attr('data-product-id');
      var mealVariantID = addedMeal.attr('id');
      var mealTitle = addedMeal.attr('data-title');
      var mealPrice = addedMeal.attr('data-price');
      var qtySelection = $('.added-detail-summary .qty-ctrl-clone .qty-selection-wrap').clone();

      if ( itemWrap.hasClass('extra-meal') ) qtySelection.addClass('extra-meal-qty');

      if ( addedMeal.val() > 0 ) {
        var mealItem = $('.added-detail-summary .detail-lists > div[id*="' + mealProductID + '"]');
        var title = $('<p class="meal-title bold">' + mealTitle + '</p>');
        var price = $('<span class="meal-price">£' + mealPrice + '</span>');
        var priceQtyWrap = $('<dive class="price-qty-wrap"></dive>');
        priceQtyWrap.append(qtySelection);
        priceQtyWrap.append(price);
        priceQtyWrap.find('.qty-selection-wrap .value').val(addedMeal.val());
        var newMealList = $('<div id="' + mealProductID + '-meal" class="meal-item"></div>');

        newMealList.append(title);
        newMealList.append(priceQtyWrap);

        if ( mealItem.length > 0 ) {
          mealItem.find('.qty-selection-wrap .value').val(addedMeal.val());
        } else {
          $('.added-detail-summary .detail-lists').append(newMealList);
        }

        if (cartParams.some(item => item.product_id === mealProductID)) {
          cartParams.map(param => {
            if ( param.product_id ==  mealProductID) {
              param.quantity = addedMeal.val();
              param.id = mealVariantID;
            }
          });
        } else {
          cartParams.push({
            product_id: mealProductID,
            id: mealVariantID,
            quantity: addedMeal.val()
          });
        }
      } else {
        $('#' + mealProductID + '-meal').remove();

        cartParams = $.grep(cartParams, function(e){ 
          return e.product_id != mealProductID; 
        });
      }
    }

    mealQtyCtrler();
    $this.change(function() {
      mealQtyCtrler();
    });
  });

  $(document).on('click', '.added-detail-summary .meal-item .qty-selection-wrap .qty-minus', function() {
    var $this = $(this);
    var productID = $this.parents('.meal-item').attr('id').replace('-meal', '');
    
    $('input[data-product-id="' + productID + '"]').parent('.product-meal-item').find('.qty-minus').click();
  });

  $(document).on('click', '.added-detail-summary .meal-item .qty-selection-wrap .qty-plus', function() {
    var $this = $(this);
    var productID = $this.parents('.meal-item').attr('id').replace('-meal', '');
    
    $('input[data-product-id="' + productID + '"]').parent('.product-meal-item').find('.qty-plus').click();
  });

  $(document).on('change', '.added-detail-summary .meal-item .qty-selection-wrap .value', function() {
    var $this = $(this);
    var productID = $this.parents('.meal-item').attr('id').replace('-meal', '');
    
    $('input[data-product-id="' + productID + '"]').parent('.product-meal-item').find('.value').val($(this).val()).change();
  });

  /** Plan Steps */
  // $('.order-checkout .checkout-info .value').text(limitPrice.val());
  limitPrice.change(function() {
    if (parseInt(extraQty.val()) > 0) {
      var extraPriceCalc = 0;
      $('.product-meal-item.extra-meal').each(function() {
        var $this = $(this);
        var price = $this.find('.meal-qty').attr('data-price');
        var qty = $this.find('.meal-qty').val();

        extraPriceCalc = extraPriceCalc + (parseInt(price) * parseInt(qty));
      });

      var totalPrice = parseInt(limitPrice.val()) + extraPriceCalc;

      //$('.order-checkout .checkout-info .value').text(totalPrice);
      $('.order-checkout .checkout-info .value').text("ON INVOICE");
    } else {
      //$('.order-checkout .checkout-info .value').text(limitPrice.val());
      $('.order-checkout .checkout-info .value').text("ON INVOICE");
    }
  });

  planDay.change(function() {
    $('.order-checkout .checkout-info .fuel-plan-price .desc').text('P&P £4.95');
  });

  planStep.change(function() {
    $('.order-steps .step').each(function() {
      var $this = $(this);

      if ( parseInt(planStep.val()) < 2 && $('.order-steps .meals-step').hasClass('current-step') ) return;

      $this.removeClass('before-step current-step passed-step');
      if ( parseInt(planStep.val()) == $this.data('step') ) $this.addClass('current-step');
      if ( parseInt(planStep.val()) > $this.data('step') ) $this.addClass('passed-step');
      if ( parseInt(planStep.val()) < $this.data('step') ) $this.addClass('before-step');

      if ( planStep.val() == 2 ) {
        //$('.order-checkout .checkout-info').removeClass('hidden');
      }
    });
  });

  /** Mobile Summary Popup */
  $('.mobile-summary-nav').on('click', function() {
    $('.meals-selection .order-summary').addClass('show');
  });

  $('.mobile-close-summary').on('click', function() {
    $('.meals-selection .order-summary').removeClass('show');
  })

  /** Meal Type Filtering */
  $('.meal-filter-wrap .type-filter-btn').on('click', function() {
    console.log("type-filter-btn click");
    var $this = $(this),
        selectedType = $this.data('type');


    $('.meal-filter-wrap .type-filter-btn').removeClass('active');
    $this.addClass('active');
    
    $('.main-meal-selection .meals-grid-wrap .product-meal-item').removeClass('hide');

    if ( selectedType != 'All' ) {
      $('.main-meal-selection .meals-grid-wrap .product-meal-item[data-type!="' + selectedType + '"]').addClass('hide');
    }
  });

  /** Meal Tag Filtering */
  $('.meal-filter-wrap .tags-filter').on('click', function() {
    $('.meal-filter-tags').addClass('show');
    $('body').addClass('overflow-y-hidden');
  });

  $('.meal-filter-tags .filter-heading .close-filter').on('click', function() {
    $('.meal-filter-tags').removeClass('show');
    $('body').removeClass('overflow-y-hidden');
  });

  $('.meal-filter-tags .tag-filter-btn').on('click', function() {
    var $this = $(this);
    
    
    var tagFilterString = [];

    if ( $this.hasClass('clicked') ) {
      $this.removeClass('clicked');
    } else {
      $this.parents('.filter-group-item').find('.tag-filter-btn').removeClass('clicked');
      $this.addClass('clicked');
    }

    $('.meal-filter-tags .tag-filter-btn').each(function() {
      var $this = $(this);

      if ( $this.hasClass('clicked') ) {
        tagFilterString.push($this.data('tag'));
      } else {
        tagFilterString = $.grep(tagFilterString, function(value) {
          return value != $this.data('tag');
        });
      }

      $('.main-meal-selection .meals-grid-wrap .product-meal-item').removeClass('hide');

      if ( tagFilterString.length > 0 ) {
        $('.main-meal-selection .meals-grid-wrap .product-meal-item').each(function() {
          var $this = $(this);
          var mealTags = $this.data('tags');
          let hasAllElems = true;

          for (let i = 0; i < tagFilterString.length; i++) {
            if ( !mealTags.includes(tagFilterString[i]) ) {
              hasAllElems = false;
              break;
            }
          }
    
          if ( hasAllElems ) {
            $this.removeClass('hide');
          } else {
            $this.addClass('hide');
          }
        });
      }
    });
  })

  /** Chef's Selection */
  $('.meal-chef-selection').on('click', function() {
    var selectionNum = limitQty.val();
    
    if ($('[data-tag="gluten free"]').hasClass('clicked')) {
      $('.meals-grid-wrap .product-meal-item').each(function() {
        var $this = $(this);

        if ( chef_collection_gluten.includes($this.data('product-id')) ) {
          $this.attr('data-chef', true);
        } else {
          $this.removeAttr('data-chef');
        }
      });
    } else if ($('[data-tag="dairy free"]').hasClass('clicked')) {
      $('.meals-grid-wrap .product-meal-item').each(function() {
        var $this = $(this);
        
        if ( chef_collection_dairy.includes($this.data('product-id')) ) {
          $this.attr('data-chef', true);
        } else {
          $this.removeAttr('data-chef');
        }
      });
    } else if ($('[data-tag="meat free"]').hasClass('clicked')) {
      $('.meals-grid-wrap .product-meal-item').each(function() {
        var $this = $(this);
        
        if ( chef_collection_meat.includes($this.data('product-id')) ) {
          $this.attr('data-chef', true);
        } else {
          $this.removeAttr('data-chef');
        }
      });
    } else {
      $('.meals-grid-wrap .product-meal-item').each(function() {
        var $this = $(this);
        
        if ( chef_collection_all.includes($this.data('product-id')) ) {
          $this.attr('data-chef', true);
        } else {
          $this.removeAttr('data-chef');
        }
      });
    }
    
    var chefProducts = $('.product-meal-item[data-chef=true]');

    if ( chefProducts.length == 0 ) return;

    if ( chefProducts.length > selectionNum ) {
      chefProducts.each(function(index) {
        var $this = $(this);
        $this.find('.meal-add-cart .add-cart-btn').click();

        return index < selectionNum- 1;
      });
    } else {
      var leftCount = selectionNum - chefProducts.length;
      var remainder = leftCount % chefProducts.length;

      chefProducts.each(function() {
        var $this = $(this);
        $this.find('.meal-add-cart .add-cart-btn').click();
      });
      
      for (let i = 0; i < Math.floor(leftCount / chefProducts.length); i++) {
        chefProducts.each(function() {
          var $this = $(this);
          $this.find('.meal-add-cart .qty-selection-wrap .qty-plus').click();
        });
      }

      if ( remainder > 0 ) {
        chefProducts.each(function(index) {
          var $this = $(this);
          $this.find('.meal-add-cart .qty-selection-wrap .qty-plus').click();

          return index < remainder - 1;
        });
      }
    }
  });

  /** Checkout */

  
  $(document).on('click', '.js-checkout-btn', function() {

    if (window.company_account.active){
      showConfirmationDialog();
      return;
    }
      

    console.log('� ~ file: theme.js [597] ~ cartParams =>', cartParams);

    let queryParams = cartParams;
    let reversedParams = [];
    let day = $('#meal-plan-day').val();
    let date = $('#meal-plan-day').attr('data-date');
    let dateText = $('#meal-plan-day').attr('data-date-text');
    let preference = "All";

    for (let i = queryParams.length - 1; i >= 0; i --) {
      reversedParams.push(queryParams[i]);
    }

    if ($('.filter-group-item--preference .tag-filter-btn.clicked').length) {
      preference = $('.filter-group-item--preference .tag-filter-btn.clicked.tag-name').text();
    }

    if (day == 'Tue') {
      reversedParams.push(window.fb_tue[0]);
    }

    else if (day == 'Wed') {
      reversedParams.push(window.fb_wed[0]);
    }

    else if (day == 'Thu') {
      reversedParams.push(window.fb_thu[0]);
    }

    else if (day == 'Fri') {
      reversedParams.push(window.fb_fri[0]);
    }

    else if (day == 'Sat') {
      reversedParams.push(window.fb_sat[0]);
    }

    else if (day == 'Sun') {
      reversedParams.push(window.fb_sun[0]);
    }

    if ($('[data-tag="gluten free"]').hasClass('clicked')) {
      preference = "Gluten Free";
    } else if ($('[data-tag="dairy free"]').hasClass('clicked')) {
      preference = "Dairy Free";
    } else if ($('[data-tag="meat free"]').hasClass('clicked')) {
      preference = "Meat Free";
    }

    $.ajax({ // Clear Cart
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      beforeSend: function () {
        $('#loader').removeClass('hidden');
      },
      success: function() {
        $.ajax({ // Add items to Cart
          type: 'POST',
          url: '/cart/add.js',
          data: {
            items: reversedParams
          },
          dataType: 'json',
          success: function() {
            $.ajax({ // Attach Date, Preference
              type: 'POST',
              url: '/cart/update.js',
              data: {
                attributes: {
                  'Delivery Date': date,
                  'Preference': preference,
                  'First Delivery': date,
                  'Delivery Date Text': dateText
                }
              },
              dataType: 'json',
              success: function() {
                window.location.href = '/checkout';
              }
            });
          }
        });
      }
    });
  });

  $('.extra-meal-selection').on('click', function(e) {
    if ( !$(e.target).is(".extra-meal-selection-inner, .extra-meal-selection-inner *") ) {
      $('.extra-meal-selection .close-popup').click();
    }
  });

  /** Checkout Reminder */
  if ( window.checkout_reminder ) {
    planStep.val(2).trigger('change');
    $('.order-checkout .checkout-info').removeClass('hidden');
  }

  // Register Customer account
  $(document).on('click', '.js-create-account', function (e) {     
    if ( $('input[name="customer[password]"]').val() != $('input[name="customer[password_confirmation]"]').val()) {
      e.preventDefault();
      alert('Passwords do not match.');
    }
    else {
      $(this).parents('form').submit();
    }
  });

  // Choose fuel - customer portal
  $(document).on('click', '.js-rc-choose-meal', function () {
    $('.total-meals-limit').val($('.subscription-qty').data('qty'));
    $('.limit-qty').text($('.subscription-qty').data('qty'));
    $('body').addClass('locked');
    $('.choose-fuel-popup').addClass('show');
  });

  $('.choose-fuel-popup .close-popup').on('click', function() {
    var $this = $(this);
    $this.parents('.choose-fuel-popup').removeClass('show');
    $('body').removeClass('locked');
  });

  $(document).on('click', '.js-rc-update-fuel', function () {
    function addMeal(index) {
      if (index == cartParams.length) {
        $('#loader').addClass('hidden');
        ReCharge.Toast.addToast("Success", "Successfully updated your next Fuel Box.");
        return;
      }
      (async () => {
        let addressId = ReCharge.Novum.subscription.address_id;
        let nextChargeDate = ReCharge.Novum.subscription.next_charge_scheduled_at;
        let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes?token=${window.customerToken}`;
        let variantId = cartParams[index].id;
        let quantity = cartParams[index].quantity;

        let data = {
          shopify_variant_id: variantId,
          address_id: addressId,
          quantity: quantity,
          next_charge_scheduled_at: nextChargeDate
        }

        /*
        await fetch(url, {
          method: 'POST',
          body: JSON.stringify(data),
          header: '"Content-Type", "application/json"'
        }).then(response => response.json()).then(reponse => {
          console.log(response);
        });
        */

    
        try {
          const response = await axios.post(url, data).then(response => {
            // Successful request made
            console.log("Attempted add onetime, response from api:"); 
            console.log(response.data);

            $('.rc-onetimes').append(`
              <div class="rc-meals__row" data-onetime-id="${response.data.onetime.id}" data-product-id="${response.data.onetime.shopify_product_id}" data-variant-id="${response.data.onetime.shopify_variant_id}">
                ${response.data.onetime.product_title} x ${response.data.onetime.quantity}
              </div>
            `);

            addMeal(index + 1);
          });
        } catch (error) {
          // Request failed
          console.error(error);
          addMeal(index);
        }
      })();
    }
    $('.choose-fuel-popup').removeClass('show');
    $('#loader').removeClass('hidden');
    $('body').removeClass('locked');
    $('.rc-meals__note').hide();
    $('.js-rc-choose-meal').hide();
    addMeal(0);
  });

  // Add onetime purchase
  $(document).on('click', '.js-rc-upsell-add', function () {
    let variantId = $(this).data('variant-id');
    let addressId = ReCharge.Novum.subscription.address_id;
    let nextChargeDate = ReCharge.Novum.subscription.next_charge_scheduled_at;
    

    if ($(this).hasClass('added')) { // Remove product
      $(this).addClass('loading');
      let onetimeId = $(`.rc-extras__row[data-variant-id="${variantId}"]`).data('onetime-id');
      let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes/${onetimeId}/cancel?token=${window.customerToken}`;

      (async () => {    
        try {
          const response = await axios.post(url);
          // Successful request made
          console.log("Attempted remove onetime, response from api:"); 
          console.log(response.data);
          
          $(this).removeClass('loading');
          $(this).removeClass('added');
          $(this).addClass('active');
          $(this).parent().find('.rc-upsell-qty').removeClass('active');
          
          $(`.rc-extras__row[data-onetime-id="${onetimeId}"]`).remove();
    
          ReCharge.Toast.addToast("Success", "Successfully removed from next box");
    
        } catch (error) {
          // Request failed
          console.error(error);
        }    
      })();
    }
    else { // Add product
      $(this).addClass('loading');
      let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes?token=${window.customerToken}`;

      (async () => {

        let data = {
          shopify_variant_id: variantId,
          address_id: addressId,
          quantity: 1,
          next_charge_scheduled_at: nextChargeDate
        }
    
        try {
          const response = await axios.post(url, data);
          // Successful request made
          console.log("Attempted add onetime, response from api:"); 
          console.log(response.data);
          
          $(this).removeClass('loading');
          $(this).addClass('added');
          $(this).removeClass('active');
          $(this).parent().find('.rc-upsell-qty').addClass('active');
          $('.rc-onetimes').append(`
            <div class="rc-extras__row" data-onetime-id="${response.data.onetime.id}" data-product-id="${response.data.onetime.shopify_product_id}" data-variant-id="${response.data.onetime.shopify_variant_id}">
              <span class="extras__title">${response.data.onetime.product_title} x 1</span>
              <span class="extras__price">${ReCharge.Novum.Utils.getCurrency()}${response.data.onetime.price}</span>
            </div>
          `);
    
          ReCharge.Toast.addToast("Success", "Successfully added to next box");
    
        } catch (error) {
          // Request failed
          console.error(error);
        }    
      })();
    }
    /*
    fetch("/tools/recurring/access", {
      headers: {
          "x-recharge-storefront-access-token": "sk_1x1_bf85fda4c1e82f0f8df804b8d7602a3d77f6587f727b75949a84e62d5b01ca38"
      }
    }).then(response => response.json()).then(json => {

      var myHeaders = new Headers();
      myHeaders.append("X-Recharge-Version", "2021-11");
      myHeaders.append("X-Recharge-Access-Token", json.api_token);
      myHeaders.append("Content-Type", "application/json");
  
      var data = JSON.stringify({"batch_type":"onetime_create"});

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: data,
        redirect: 'follow'
      };

      fetch("https://api.rechargeapps.com/async_batches?shop_url=" + Shopify.shop, requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

      var url = "https://api.rechargeapps.com/async_batches?shop_url=" + Shopify.shop;
      fetch(url, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-Recharge-Access-Token": 'sk_1x1_bf85fda4c1e82f0f8df804b8d7602a3d77f6587f727b75949a84e62d5b01ca38',
          "X-Recharge-Version": "2021-11",
          "Content-Type": "application/json"
        },
        body: '{"batch_type":"onetime_create"}'
      }).then(response => response.json())
        .then(json => {
          console.log(json);
        });
    });
    */
  });

  // Update onetime quantity
  $(document).on('click', '.rc-upsell-qty__minus', function () {
    let value = parseInt($(this).parents('.rc-upsell-qty').find('.value').text());
    let newValue = value - 1;
    let variantId = $(this).parents('.rc-upsell-qty').data('variant-id');

    let onetimeId = $(`.rc-extras__row[data-variant-id="${variantId}"]`).data('onetime-id');

    $(this).parents('.rc-upsell-qty').addClass('disabled');

    if (newValue == 0) {
      let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes/${onetimeId}/cancel?token=${window.customerToken}`;

      (async () => {    
        try {
          const response = await axios.post(url);
          // Successful request made
          console.log("Attempted remove onetime, response from api:"); 
          console.log(response.data);
          
          $(this).parents('.rc-upsell-qty').removeClass('disabled');
          $(this).parents('.rc-upsell-qty').find('.value').text(newValue);
          $(this).parents('.rc-upsell-qty').removeClass('active');
          $(this).parents('.meal-add-cart').find('.rc-upsell-add').addClass('active');
          $(this).parents('.meal-add-cart').find('.rc-upsell-add').removeClass('added');
          
          $(`.rc-extras__row[data-onetime-id="${onetimeId}"]`).remove();
    
          ReCharge.Toast.addToast("Success", "Successfully removed from next box");
    
        } catch (error) {
          // Request failed
          console.error(error);
        }    
      })();
    }
    else {
      let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes/${onetimeId}?token=${window.customerToken}`;

      (async () => {
        let data = {
          quantity: newValue
        }
    
        try {
          const response = await axios.post(url, data);
          // Successful request made
          console.log("Attempted update onetime, response from api:"); 
          console.log(response.data);
          
          $(this).parents('.rc-upsell-qty').removeClass('disabled');
          $(this).parents('.rc-upsell-qty').find('.value').text(newValue);

          $(`.rc-extras__row[data-onetime-id="${response.data.onetime.id}"] .extras__title`).text(`${response.data.onetime.product_title} x ${response.data.onetime.quantity}`);
          $(`.rc-extras__row[data-onetime-id="${response.data.onetime.id}"] .extras__price`).text(`${ReCharge.Novum.Utils.getCurrency()}${(response.data.onetime.price * response.data.onetime.quantity).toFixed(2)}`);
          ReCharge.Toast.addToast("Success", "Successfully updated quantity");

        } catch (error) {
          // Request failed
          console.error(error);
        }    
      })();
    }
  });

  $(document).on('click', '.rc-upsell-qty__plus', function () {
    let value = parseInt($(this).parents('.rc-upsell-qty').find('.value').text());
    let newValue = value + 1;
    let variantId = $(this).parents('.rc-upsell-qty').data('variant-id');

    let onetimeId = $(`.rc-extras__row[data-variant-id="${variantId}"]`).data('onetime-id');
    let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes/${onetimeId}?token=${window.customerToken}`;

    $(this).parents('.rc-upsell-qty').addClass('disabled');

    (async () => {
      let data = {
        quantity: newValue
      }
  
      try {
        const response = await axios.post(url, data);
        // Successful request made
        console.log("Attempted update onetime, response from api:"); 
        console.log(response.data);
        
        $(this).parents('.rc-upsell-qty').removeClass('disabled');
        $(this).parents('.rc-upsell-qty').find('.value').text(newValue);

        $(`.rc-extras__row[data-onetime-id="${response.data.onetime.id}"] .extras__title`).text(`${response.data.onetime.product_title} x ${response.data.onetime.quantity}`);
        $(`.rc-extras__row[data-onetime-id="${response.data.onetime.id}"] .extras__price`).text(`${ReCharge.Novum.Utils.getCurrency()}${(response.data.onetime.price * response.data.onetime.quantity).toFixed(2)}`);
        ReCharge.Toast.addToast("Success", "Successfully updated quantity");
      } catch (error) {
        // Request failed
        console.error(error);
      }    
    })();
  });

  // Select regular/performance

  function daysToNextProductionDay(nextDayOfWeek, givenDate) {
    // Ensure givenDate is a Date object
    let date = new Date(givenDate);

    // Get the day of week (0 = Sunday, 2 = Tuesday)
    let dayOfWeek = date.getDay();

    // Tuesday is 2
    let diff = (nextDayOfWeek - dayOfWeek + 7) % 7;

    // If it's already Tuesday, "next Tuesday" means 7 days later
    if (diff === 0) diff = 7;

    return diff;
  }




  $(document).on('click', '.meal-variants__item', function () {
    let $mealItem = $(this).parents('.product-meal-item');
    $mealItem.find('.meal-variants__item--active').removeClass('meal-variants__item--active');
    $(this).addClass('meal-variants__item--active');
    $mealItem.find('.meal-qty').attr('data-price', $(this).attr('data-variant-price'));
    $mealItem.find('.meal-qty').attr('data-title', $(this).attr('data-variant-title'));
    $mealItem.find('.meal-qty').attr('id', $(this).attr('data-variant-id'));

    if (!$mealItem.find('.add-cart-btn').hasClass('active')) {
      let productID = $mealItem.find('.meal-qty').attr('data-product-id');
      $('#' + productID + '-meal').find('.meal-title').text($(this).attr('data-variant-title'));
      $mealItem.find('.meal-qty').trigger('change');
      
      var totalPriceCalc = 0.0;
      $('.product-meal-item').each(function() {
        var $this = $(this);
        var price = $this.find('.meal-qty').attr('data-price');
        var qty = $this.find('.meal-qty').val();
  
        totalPriceCalc = totalPriceCalc + (parseFloat(price) * parseFloat(qty));
      });
  
      //$('.order-checkout .checkout-info .value').text(totalPriceCalc.toFixed(2));
      $('.order-checkout .checkout-info .value').text("ON INVOICE");
    }
  });

  if ($('.plan-day-item.active').length) {
    $('.plan-day-item.active').trigger('click');
      
    var totalPriceCalc = 0.0;
    $('.product-meal-item').each(function() {
      var $this = $(this);
      var price = $this.find('.meal-qty').attr('data-price');
      var qty = $this.find('.meal-qty').val();

      totalPriceCalc = totalPriceCalc + (parseFloat(price) * parseFloat(qty));
    });

    //$('.order-checkout .checkout-info .value').text(totalPriceCalc.toFixed(2));
    $('.order-checkout .checkout-info .value').text("ON INVOCIE");
    $('.plan-checkout-btn').prop('disabled', false);
  }

  /* Date picker */
  let prevSelectDeliveryDate = null;
  let now = new Date();
  let minDate = new Date();
  let maxDate = new Date();

  // now = new Date("09/13/2025");
  // console.log(now);
  

  console.log("current week day: "+now.getDay());
  let weekDay = now.getDay(); //sunday (0) - saturday (6)
  

  
  // if (now.getHours() < 23){
  //   minDate.setDate(now.getDate() + 5);
  // } else {
  //   minDate.setDate(now.getDate() + 6);
  // }

  
  var _nextProductionDayOfWeek = 2; // 2 for tuesday, 5 for friday

  if (weekDay == 6 || weekDay == 0 || weekDay == 1 || weekDay == 2){
    _nextProductionDayOfWeek = 5;
  }
  var _daysToNextProductionDay = daysToNextProductionDay(_nextProductionDayOfWeek, now);
  console.log("daysToNextProductionDay: "+_daysToNextProductionDay);
  if (window.company_account && window.company_account.active){
    var _leadTimeDays = parseInt(window.company_account.plan.lead_time_days);
    if (_leadTimeDays > _daysToNextProductionDay){
      _daysToNextProductionDay = _leadTimeDays;
    }
  }
console.log("daysToNextProductionDay: "+_daysToNextProductionDay);
  

  minDate.setDate(now.getDate() + (_daysToNextProductionDay+1));
  
  maxDate.setDate(now.getDate() + 28);
  
  console.log("minDate: "+minDate);
  console.log("maxDate: "+maxDate);
  
  var disabledDays = ["20-04-2025","21-04-2025","22-04-2025","05-05-2025","06-05-2025","26-08-2025"];
  $('.plan-day__picker').datepicker({
    minDate: minDate,
    maxDate: maxDate,
    dateFormat: 'DD d M',
    firstDay: 1,
    beforeShowDay: function (d) {
       
      //if (d.getDay() != 1){
        var current_date_string = $.datepicker.formatDate('dd-mm-yy', d);
        console.log(current_date_string);
        var current_date_weekday = $.datepicker.formatDate('DD', d);
        console.log(current_date_weekday);
        if ((current_date_string == "31-08-2026") || (current_date_string == "07-04-2026") || (current_date_string == "06-04-2026") || (current_date_string == "05-04-2026") || (current_date_string == "03-04-2026") || (current_date_string == "22-12-2025") || (current_date_string == "25-12-2025") || (current_date_string == "26-12-2025") || (current_date_string == "27-12-2025") || (current_date_string == "28-12-2025" || (current_date_string == "29-12-2025") || (current_date_string == "30-12-2025") || (current_date_string == "01-01-2026") || (current_date_string == "02-01-2026") )){
          return [false];
        } else {
          if (window.company_account && window.company_account.active && (window.company_account.plan.delivery_days.length > 0) ){
            return window.company_account.plan.delivery_days.includes(current_date_weekday) ? [true] : [false];
          } else {
            return [true];
          }
        }
        
      //} else {
      //  return [false];
      //}
      //return [(d.getDay() != 1)];
    },
    onSelect: function (d, inst) {

      
      menuDateSelected(d, inst);
      var selected_plan_date = $('#meal-plan-day').attr('data-date');
      showSavedMeals(selected_plan_date);
    }
  });
  function menuDateSelected(d, inst){
    //alert("menuDateSelected");
    var selected_plan_date = $('#meal-plan-day').attr('data-date');
      console.log("menuDateSelected: "+selected_plan_date);
      //console.log(d+ " : "+ inst.selectedMonth+" : "+$(this).datepicker('getDate'));

    
      let day = d.slice(0, 3);
      let date = '';
      date += ('0' + inst.selectedDay).slice(-2) + '-';
      date += ('0' + (inst.selectedMonth + 1)).slice(-2) + '-';
      date += inst.selectedYear;

      let selectDeliveryDate = '';
      selectDeliveryDate += ('0' + (inst.selectedMonth + 1)).slice(-2) + '/';
      selectDeliveryDate += ('0' + inst.selectedDay).slice(-2) + '/';
      selectDeliveryDate += inst.selectedYear;
      console.log("selectDeliveryDate:"+selectDeliveryDate);
    $('#meal-plan-day').val(day);
      $('#meal-plan-day').attr('data-date', date);
      $('#meal-plan-day').attr('data-date-text', d);
      $('.product-meals.meals-selection').removeClass('pointer-events-none');
      
      if (selectDeliveryDate == "" || selectDeliveryDate.length != 10){
        console.log("empty plan date");
      } else {
        // var _selected_plan_date_month = selected_plan_date.split("-")[1];
        // var _new_plan_date_month = date.split("-")[1];
        // if (_selected_plan_date_month != _new_plan_date_month){
        //   clearSelectedMeals();
        // }
        console.log("delivery date: "+selectDeliveryDate);

      
        let selectDeliveryDataTS = new Date(selectDeliveryDate).getTime();

        
        $(".weekly-meals-date-tab").removeClass("delivery");
        $(".weekly-meals-date-tab").removeClass("active");
        $(".meals-selection-wrap .meals-grid-wrap").removeClass("delivery");  
        $(".meals-selection-wrap .main-meal-selection .meals-grid-wrap").hide();
        $(".meals-selection-wrap .main-meal-selection .meals-grid-wrap .meal-add-cart").hide();
        
        
        for (var i=1;i<=4;i++){
         
          var menuStartDateTS = new Date($("#weekly-meals-date-tab-"+i).data("startdate")).getTime();
          var menuEndDateTS = new Date($("#weekly-meals-date-tab-"+i).data("enddate")).getTime();
          //console.log(i+" : "+menuStartDateTS+" : "+menuEndDateTS+" : "+selectDeliveryDataTS);
          if (selectDeliveryDataTS>=menuStartDateTS && selectDeliveryDataTS<=menuEndDateTS ){
            //console.log("select: "+i);
            $("#weekly-meals-date-tab-"+i).addClass("delivery");
            $("#weekly-meals-date-tab-"+i).trigger("click");
            $("#weekly-meals-selection-"+i).addClass("delivery");
            $("#weekly-meals-selection-"+i+" .meal-add-cart").show();
            $("#no-meal-ready-for-choose").hide();
          }
        }

        if ($(".meals-selection-wrap .main-meal-selection .meals-grid-wrap:visible").length <= 0){
          $("#no-meal-ready-for-choose").css({"display":"block"}); 
          $("#no-meal-ready-for-choose").show(); 
        
        }

        if (prevSelectDeliveryDate !== null) {
          if (!areSameWeeks(new Date(prevSelectDeliveryDate), new Date(selectDeliveryDate), 3)){
            clearSelectedMeals();
            
            
          } 
        }

        prevSelectDeliveryDate = selectDeliveryDate;
        
        
        
        
      }


      //showMealsMenu(inst.selectedMonth);
    
      
    
        

    

    
  }

  function areSameWeeks(date1, date2, boundaryDay=0)
{
    if(date1 > date2)
    {
        let t = date1;
        date1 = date2;
        date2 = t;
    }

    if(((((date2 - date1)/1000)/3600)/24)>6)
    {
        return false;
    }

    let day1 = date1.getUTCDay();
    let day2 = date2.getUTCDay();

    if(day1 == boundaryDay)
    {
        return true;
    }

    if(day2 == boundaryDay)
    {
        return false;
    }

    let d1BoundaryDist = ((day1-boundaryDay)+7)%7;
    let d2BoundaryDist = ((day2-boundaryDay)+7)%7;

    if(d1BoundaryDist <= d2BoundaryDist)
    {
        return true;
    }

    return false;
}
  /*month menu*/
  function showMealsMenu(selected_month){
    //console.log(date);
    var _current_month = now.getMonth();
    if (_current_month == selected_month){
      $("#current-month-meal-selection").show();
      $("#next-month-meal-selection").hide();
    } else {
      $("#current-month-meal-selection").hide();
      $("#next-month-meal-selection").show();
    }
  }
  function clearSelectedMeals(){
    $.ajax({ // Clear Cart
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      beforeSend: function () {
        
      },
      success: function() {
        
      }
    });
    console.log("clearSelectedMeals");
    $(".detail-lists .qty-selection-wrap .value").each(function(){
      $(this).val(0).change();
      
    });
  }

  function initMealsMenu(){

    
    var selected_plan_date_arr = $('#meal-plan-day').attr('data-date').split("-");
    //console.log(selected_plan_date_arr[1]+"/"+selected_plan_date_arr[0]+"/"+selected_plan_date_arr[2]);
    if (selected_plan_date_arr.length == 3){
      //$('.plan-day__picker').datepicker('setDate', selected_plan_date_arr[0]+"/"+selected_plan_date_arr[1]+"/"+selected_plan_date_arr[2]);
      //console.log(new Date(selected_plan_date_arr[2],selected_plan_date_arr[1],selected_plan_date_arr[0]));
      //$('.plan-day__picker').datepicker('setDate', new Date(selected_plan_date_arr[2],selected_plan_date_arr[1]-1,selected_plan_date_arr[0]));
      //console.log($('.plan-day__picker').datepicker("getDate"));
      
      //$('.plan-day__picker').change();
      var id = document.getElementById('plan-day__picker'); 
      //replace someId with the id of the datepicker currently visible.  
      var inst = window.$.datepicker._getInst(id);
      menuDateSelected($('#plan-day__picker').val(), inst);
      
    }
    
    
  }



  async function getSavedMeals(args){


    var _data = {
      "company_id":window.company_account.id, 
      "location_id":window.company_account.available_locations[0].id, 
    };
    //console.log(_data);


    //alert("getSavedMeals");

    let formData = new FormData();
    formData.append("action", "check");
    formData.append("data", JSON.stringify(_data));
    formData.append("id", window.customer.id); // shopify customer id
    formData.append("email", window.customer.email ); // shopify customer email
    formData.append("hash", window.customer.hash ); // shopify hash

    await fetch(window.customer.apiUrl+"get_saved_meals", {
    //await fetch("//localhost:8081/save_meals", {
      method: "POST",
      //mode: "no-cors", // no-cors, *cors, same-origin
      cache: "no-cache",
      // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      body: formData,
      //headers: {'Accept': 'application/json','Content-Type': 'application/json'},
    }).then((response) => response.json()).then((data) => {
      if (data.hasOwnProperty("data") && data["data"].hasOwnProperty("data") ) {
        if (Object.keys(data).length > 0 ){
          window.company_account.draft_orders = data["data"]["data"];
          var _deliveryDate = Object.keys(window.company_account.draft_orders)[0];
          //alert(_deliveryDate);
          
          const picker = $('.plan-day__picker');
          console.log("_deliveryDate"+ _deliveryDate);
          console.log(new Date(_deliveryDate));
          picker.datepicker('setDate', parseDDMMYYYY(_deliveryDate));

          const inst = $.datepicker._getInst(picker[0]);

          menuDateSelected(picker.val(), inst);


          showSavedMeals(_deliveryDate);
          showSavedDraftOrders();

        } else {
          window.company_account.draft_orders = [];
        }
        
        
      }
      
    
    }).catch((error) => {
      console.log(error);
      
    });
  }

  function showSavedDraftOrders(){
    
    $("#shopify-section-product-fuelplan-saved-draft-orders").show();

    Object.entries( window.company_account.draft_orders).forEach(([date, orderInfo]) => {
      
      var _mealQty = 0 ;
      for (const meal of orderInfo.meals) {
          _mealQty += meal.quantity;
      }
      if (_mealQty > 0 ){
        var _html = `<div class="draftOrderItem" onclick="swapeDeliveryDate('${date}')">
          <div class="date">Delivery on: ${formatDateDDdM(parseDDMMYYYY(date))}</div>
          <div class="info">
            <div class="items">Saved Items: ${_mealQty}</div>
            <div class="act"><span >Edit</span></div>
          </div>
        </div>`;  
        $("#saved-draft-orders-list-container").prepend(_html);
      }
    });
    
    $("#saved-draft-orders-container").show();
  }
  
  function showSavedMeals(deliveryDate){
    //console.log("getSavedMeals");
    var _draftOrdersObj = window.company_account.draft_orders;

    //console.log(_draftOrdersObj);
    clearSelectedMeals();
    //saved meals object key: delivery date, value: meals, for now just support single delivery date
    //console.log(window.company_account.plan.delivery_date);
    
    var _draftOrders = _draftOrdersObj[deliveryDate] ?? null;
    if (!_draftOrders){
      return
    }
    var _savedMeals = _draftOrdersObj[deliveryDate]["meals"] ?? [];
    
    //var _savedMeals = Object.values(_draftOrdersObj)[0]["meals"];
    
    let allMenuProducts = $(".meals-grid-wrap.delivery").find(".product-meal-item ");

    console.log(_savedMeals);


    _savedMeals.forEach(item => {
        // Extract the numeric ID from the GID string
        const numericId = item.variantId.split('/').pop();
        

        $(allMenuProducts).each(function(){
                
          if ($(this).data("variant-id") == numericId){
            $(this).find(".meal-add-cart").find(".value").val(item.quantity);
            $(this).find(".meal-add-cart").find(".value").trigger("change");
            $(this).find(".add-cart-btn").removeClass("active");
            $(this).find(".qty-selection-wrap").addClass("active");
            //console.log(`Variant ID: ${numericId}, Quantity: ${item.quantity}`);

          }
        });
        
    });
    if (_savedMeals.length >0){
      $(".save-state").show();
    }
  }

  window.showSavedMeals = showSavedMeals;

  window.menuDateSelected = menuDateSelected;

  async function confirmClearMeals(){


    var deliveryData = $('#meal-plan-day').data("date");
    var deliveryDataText = $('#meal-plan-day').data("date-text");
    
    var _data = {
      "delivery_date":deliveryData, 
      "cutoff":getCutoffDateTime(deliveryData, parseInt(window.company_account.plan.lead_time_days)),
      "delivery_date_text":deliveryDataText, 
      "company_id":window.company_account.id, 
      "location_id":window.company_account.available_locations[0].id, 
      "meals":[]
    };
//    console.log(_data);




    let formData = new FormData();
    formData.append("action", "check");
    formData.append("data", JSON.stringify(_data));
    formData.append("id", window.customer.id); // shopify customer id
    formData.append("email", window.customer.email ); // shopify customer email
    formData.append("hash", window.customer.hash ); // shopify hash


    $('#loader').removeClass('hidden');
    $("#confirmation-clear-dialog").hide();
      
    await fetch(window.customer.apiUrl+"save_meals", {
    //await fetch("//localhost:8081/save_meals", {
      method: "POST",
      //mode: "no-cors", // no-cors, *cors, same-origin
      cache: "no-cache",
      // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      body: formData,
      //headers: {'Accept': 'application/json','Content-Type': 'application/json'},
    }).then((response) => response.json()).then((data) => {
      console.log(data);
      
      setTimeout(function(){
        $("#confirmation-clear-dialog").hide();
        $('#loader').addClass('hidden');
        window.location.reload();
      }, 10000);
      
    
    }).catch((error) => {
      console.log(error);
      
    });
  }

  function getCutoffDateTime(deliveryDateStr, leadTimeDays) {
    // Parse the input date string (assumes DD-MM-YYYY format)
    const [day, month, year] = deliveryDateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    
    // Subtract the lead time days
    if (leadTimeDays <= 4){
      leadTimeDays = 4;
    }
    date.setDate(date.getDate() - leadTimeDays);
    
    // Set the time to the end of the day (23:59:59)
    date.setHours(23, 59, 59, 0);
    
    // Format back to DD-MM-YYYY HH:mm:ss
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    
    return `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`;
}

  async function confirmSaveMeals(){

    //alert("confirmSaveMeals");

    
    
    var deliveryData = $('#meal-plan-day').data("date");
    var deliveryDataText = $('#meal-plan-day').data("date-text");
    

    var _data = {
      "delivery_date":deliveryData, 
      "cutoff":getCutoffDateTime(deliveryData, parseInt(window.company_account.plan.lead_time_days)), 
      "delivery_date_text":deliveryDataText, 
      "company_id":window.company_account.id, 
      "location_id":window.company_account.available_locations[0].id, 
      "meals":cartParams
    };
  //  console.log(_data);
  //  return;




    let formData = new FormData();
    formData.append("action", "check");
    formData.append("data", JSON.stringify(_data));
    formData.append("id", window.customer.id); // shopify customer id
    formData.append("email", window.customer.email ); // shopify customer email
    formData.append("hash", window.customer.hash ); // shopify hash


    $('#loader').removeClass('hidden');
    $("#confirmation-dialog").hide();
      
    await fetch(window.customer.apiUrl+"save_meals", {
    //await fetch("//localhost:8081/save_meals", {
      method: "POST",
      //mode: "no-cors", // no-cors, *cors, same-origin
      cache: "no-cache",
      // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      body: formData,
      //headers: {'Accept': 'application/json','Content-Type': 'application/json'},
    }).then((response) => response.json()).then((data) => {
      console.log(data);
      setTimeout(function(){
        $("#confirmation-dialog").hide();
        $('#loader').addClass('hidden');
        window.location.reload();
      }, 10000)
      
    
    }).catch((error) => {
      console.log(error);
      
    });




  }

  function showConfirmationDialog(){
    //alert(window.company_account.name);
    //$('#loader').removeClass('hidden');
    
    var deliveryData = $('#meal-plan-day').data("date");
    var deliveryDataText = $('#meal-plan-day').data("date-text");
    $("#confirmation-dialog").show();
    $("#confirmation-dialog").find(".company_name").find("span").html(window.company_account.name);
    $("#confirmation-dialog").find(".company_addr").find("span").html("");
    if (window.company_account.available_locations.length >0 ){
      var _addr = window.company_account.available_locations[0];
      $("#confirmation-dialog").find(".company_addr").find("span").html(_addr.name);
    }

    $("#confirmation-dialog").find(".delivery_date").find("span").html(deliveryDataText);

    var _mealsHTML = "";
    
    let queryParams = cartParams;
    let allMenuProducts = $(".meals-grid-wrap.delivery").find(".product-meal-item ");

    for (let i = queryParams.length - 1; i >= 0; i --) {
      //_meals.push(queryParams[i]);
      $(allMenuProducts).each(function(){
        if ($(this).data("product-id") == queryParams[i].product_id){
          var _pName = $(this).find(".meal-qty").data("title");
          _mealsHTML += '<div>'+_pName+' <span class="qty"> x'+queryParams[i].quantity+'</span></div>';
          console.log(_pName);
        }
      });
    }

    console.log(_mealsHTML);
    $("#confirmation-dialog").find(".meals").find("span").html(_mealsHTML);

    
    
    

    
    //console.log(window.customer);
    //console.log(window.company_account);
  }

  function showClearConfirmationDialog(){
    //alert(window.company_account.name);
    //$('#loader').removeClass('hidden');
    var deliveryData = $('#meal-plan-day').data("date");
    var deliveryDataText = $('#meal-plan-day').data("date-text");
    

    $("#confirmation-clear-dialog").show();
    $("#confirmation-clear-dialog").find(".company_name").find("span").html(window.company_account.name);
    $("#confirmation-clear-dialog").find(".company_addr").find("span").html("");
    if (window.company_account.available_locations.length >0 ){
      var _addr = window.company_account.available_locations[0];
      $("#confirmation-clear-dialog").find(".company_addr").find("span").html(_addr.name);
    }

    $("#confirmation-clear-dialog").find(".delivery_date").find("span").html(deliveryDataText);

    var _mealsHTML = "";
    
    let queryParams = cartParams;
    let allMenuProducts = $(".meals-grid-wrap.delivery").find(".product-meal-item ");

    for (let i = queryParams.length - 1; i >= 0; i --) {
      //_meals.push(queryParams[i]);
      $(allMenuProducts).each(function(){
        if ($(this).data("product-id") == queryParams[i].product_id){
          var _pName = $(this).find(".meal-qty").data("title");
          _mealsHTML += '<div>'+_pName+' <span class="qty"> x'+queryParams[i].quantity+'</span></div>';
          console.log(_pName);
        }
      });
    }

    console.log(_mealsHTML);
    $("#confirmation-clear-dialog").find(".meals").find("span").html(_mealsHTML);

    
    
    

    
    //console.log(window.customer);
    //console.log(window.company_account);
  }




  if (window.company_account){
    if (window.company_account.active){
      //active company account
      //console.log(window.company_account); 

        //using cutoff time and auto fill the delivery date

        var _addr = window.company_account.available_locations[0];
        $("#saved-draft-orders-address-container").html("Delivery Address: "+_addr.name);
        $('#loader').removeClass('hidden');

        // const dateConfig = {
        //   cut_off_day: window.company_account.plan.cut_off_day,
        //   cut_off_time: window.company_account.plan.cut_off_time,
        //   delivery_day: window.company_account.plan.delivery_day
        // };
        // const result = getNextCutoffAndDelivery(dateConfig);

        //console.log("Cutoff:", result.cutoff);
        //console.log("Delivery:", result.delivery);

        // window.company_account.plan.cutoff_date_time = result.cutoff;
        // window.company_account.plan.delivery_date = result.delivery;
        console.log(window.company_account);
        
        // $("#shopify-section-product-fuelplan-day .plan-selection.day-selection .count-down-timer").data("cutoff", formatDateTime(result.cutoff));
        // $("#shopify-section-product-fuelplan-day .plan-selection.day-selection .day-selection-delivery").html(formatDeliveryDate(result.delivery));
        
        

        //$("#meal-plan-day").val(result.delivery.toLocaleDateString("en-GB", {weekday: "short"}));
        //$("#meal-plan-day").data("date", result.delivery.toLocaleDateString("en-GB").replace(/\//g, "-"));
        //alert($("#meal-plan-day").data("date")); 
        // alert(result.delivery.toLocaleDateString("en-GB").replace(/\//g, "-"));

        //$('.plan-day__picker').datepicker('setDate', formatDateDDdM(result.delivery)).trigger("select");
        // cutoffCountDown();

        setTimeout(async () => {
          

          $(".save-state span").click(function(){
            showClearConfirmationDialog();
          });
          await getSavedMeals([]);
          $('#loader').addClass('hidden');
        }, 1000);
        



        

        $("#shopify-section-product-fuelplan-day .plan-selection.day-selection .day-selection-calendar").show();
      

    } else {
      $("#shopify-section-product-fuelplan-day .plan-selection.day-selection .day-selection-calendar").show();
    }
  } else {
    $("#shopify-section-product-fuelplan-day .plan-selection.day-selection .day-selection-calendar").show();
  }

  $("#confirmation-dialog-btn-cancel").on("click", function(){
    $('#confirmation-dialog').hide();
  });

  $("#confirmation-dialog-btn-ok").on("click", function(){
   confirmSaveMeals();
  });

  $("#confirmation-clear-dialog-btn-cancel").on("click", function(){
    $('#confirmation-clear-dialog').hide();
  });

  $("#confirmation-clear-dialog-btn-ok").on("click", function(){
   confirmClearMeals();
  });



  initMealsMenu()

});




function cutoffCountDown(){
    if ($(".count-down-timer").length <=0 ) return;
    
    $(".count-down-timer").each(function( index ) {
        var cutoff_date_time_str = $(this).data("cutoff");
        if (cutoff_date_time_str) {
            // console.log(cutoff_date_time_str);
            var cutoff_date_time = moment.tz(cutoff_date_time_str, "YYYY-MM-DD HH:mm", "Europe/London");
            // console.log(cutoff_date_time.format());
            // console.log(cutoff_date_time.valueOf());
            var uk_current_date_time = moment().tz("Europe/London");
            // console.log(uk_current_date_time.format());
            // console.log(uk_current_date_time.valueOf());
            let offsetSeconds = (cutoff_date_time.valueOf()  - uk_current_date_time.valueOf()) / 1000;
            $(this).data("seconds", offsetSeconds);
            
            
        }
    
    });

    function getCountDownSeconds(which){
      var cutoff_date_time_str = $(which).data("cutoff");
      if (cutoff_date_time_str) {
          // console.log(cutoff_date_time_str);
          var cutoff_date_time = moment.tz(cutoff_date_time_str, "YYYY-MM-DD HH:mm", "Europe/London");
          // console.log(cutoff_date_time.format());
          // console.log(cutoff_date_time.valueOf());
          var uk_current_date_time = moment().tz("Europe/London");
          // console.log(uk_current_date_time.format());
          // console.log(uk_current_date_time.valueOf());
          let offsetSeconds = (cutoff_date_time.valueOf()  - uk_current_date_time.valueOf()) / 1000;
          //$(which).data("seconds", offsetSeconds);
          return offsetSeconds;
      } 
      return 0;
    }

    setInterval(function () {
                    
        $(".count-down-timer").each(function( index ) {
            //let seconds = $(this).data("seconds");

            let seconds = getCountDownSeconds($(this));
           
            seconds --;
            $(this).data("seconds", seconds);
        

            if (seconds > 0) {
                let d = Math.floor(seconds / (3600*24));
                let h = Math.floor(seconds % (3600*24) / 3600);
                let m = Math.floor(seconds % 3600 / 60);
                let s = Math.floor(seconds % 60);

                let dDisplay = d;
                let hDisplay = h;
                let mDisplay = m;
                let sDisplay = s;
                
                let dayLabel = d === 1 ? 'Day' : 'Days';
                let hourLabel = h === 1 ? 'Hour' : 'Hours';
                let minuteLabel = m === 1 ? 'Minute' : 'Minutes';
                
                $(this).html('<div class="count-down-timer__item">' + '<span>' + dDisplay + '</span><span>' + dayLabel + '</span>' + '</div>' + '<div class="count-down-timer__item">' + '<span>' + hDisplay + '</span><span>' + hourLabel + '</span>' + '</div>' + '<div class="count-down-timer__item">' + '<span>' + mDisplay + '</span><span>' + minuteLabel + '</span>' + '</div>');
                $(".subscription_item .btns a").attr("disabled", true);
                //console.log($(this).data("subs-id"));
                //$("#subscription_item_"+$(this).data("subs-id")).data("status","lock");
                $(this).parent().find("p").show();

                // $(".subscription_item").find(".cta_btn").each(function(){
                //   if ($(this).data("cta_action") == "cancelSubs"){
                //     $(this).removeClass("disabled");
                //   }
                //   if ($(this).data("cta_action") == "pauseSubs"){
                //     $(this).removeClass("disabled");
                //   }
                //   if ($(this).data("cta_action") == "showPreferenceDetails"){
                //     $(this).removeClass("disabled");
                //   }

                //   if ($(this).data("cta_action") == "gotoSubscriptionMealPicker"){
                //     $(this).removeClass("disabled");
                //   }
                //   if ($(this).data("cta_action") == "gotoManageSubscription"){
                //     $(this).removeClass("disabled");
                //   }

                // });

            }
            else {
                $(this).html('Your upcoming fuel is locked.');
                $(this).parent().parent().parent().find("btns a").attr("disabled", true);
                $("#subscription_item_"+$(this).data("subs-id")).data("status","lock");
                $(this).parent().find("p").hide();

                $(this).parent().parent().parent().find(".cta_btn").each(function(){
                  if ($(this).data("cta_action") == "cancelSubs"){
                    $(this).addClass("disabled");
                  }
                  if ($(this).data("cta_action") == "pauseSubs"){
                    $(this).addClass("disabled");
                  }
                  if ($(this).data("cta_action") == "showPreferenceDetails"){
                    $(this).addClass("disabled");
                  }

                  if ($(this).data("cta_action") == "gotoSubscriptionMealPicker"){
                    $(this).addClass("disabled");
                  }
                  // if ($(this).data("cta_action") == "gotoManageSubscription"){
                  //   $(this).addClass("disabled");
                  // }

                });
                
            }
        })
        
    }, 1000);





    
}



function getNextCutoffAndDelivery(config) {
  const weekdays = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6
  };

  const now = new Date();

  // Next cutoff
  const cutoff = new Date(now);
  const cutoffDay = weekdays[config.cut_off_day];

  let daysUntilCutoff = (cutoffDay - now.getDay() + 7) % 7;

  cutoff.setDate(now.getDate() + daysUntilCutoff);

  const [hour, minute] = config.cut_off_time.split(":").map(Number);
  cutoff.setHours(hour, minute, 0, 0);

  // If today's cutoff has passed, move to next week
  if (cutoff <= now) {
    cutoff.setDate(cutoff.getDate() + 7);
  }

  // Next delivery after cutoff
  const delivery = new Date(cutoff);
  const deliveryDay = weekdays[config.delivery_day];

  let daysUntilDelivery =
    (deliveryDay - cutoff.getDay() + 7) % 7;

  if (daysUntilDelivery === 0) {
    daysUntilDelivery = 7;
  }

  delivery.setDate(delivery.getDate() + daysUntilDelivery);

  return {
    cutoff,
    delivery
  };
}

function formatDateDDMMYY(date) {
  const pad = n => String(n).padStart(2, "0");

  return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}`;
}
function formatDateYYMMDD(date) {
  const pad = n => String(n).padStart(2, "0");

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
function formatDateTime(date) {
  const pad = n => String(n).padStart(2, "0");

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

function formatDeliveryDate(date) {
  return date.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric"
  });
}

function formatDateDDdM(date) {
  const weekday = date.toLocaleDateString("en-GB", { weekday: "long" });
  const day = date.getDate();
  const month = date.toLocaleDateString("en-GB", { month: "short" });

  return `${weekday} ${day} ${month}`;
}

function parseDDMMYYYY(dateStr) {
    const [day, month, year] = dateStr.split('-').map(Number);
    // Month is 0-indexed in JavaScript Date (0 = January, 7 = August)
    return new Date(year, month - 1, day);
}


function swapeDeliveryDate(_deliveryDate){
  const picker = $('.plan-day__picker');
    picker.datepicker('setDate', parseDDMMYYYY(_deliveryDate));
    const inst = $.datepicker._getInst(picker[0]);

    window.menuDateSelected(picker.val(), inst);


    window.showSavedMeals(_deliveryDate);

    $('html, body').animate({
                    scrollTop: $(".day-select-plan").offset().top - 100
                }, 500);
}


